import { pathSubscription, subscription } from 'nike-re-framejs';
import { nuiCtx } from '../../common/initialization';

const portalForcedActionCrm$ = pathSubscription(['account', 'user', 'forcedActionsCrm']);
const mobileForcedActionCrm$ = pathSubscription(['account', 'userData', 'forcedActionsCrm']);
export const forcedActionsCRM$ = subscription((l1, l2) => l1 || l2, portalForcedActionCrm$, mobileForcedActionCrm$);
export const userNickName$ = subscription(db => {
    const isNickName = db.getIn(['account', 'userData', 'nickname']);
    if (isNickName !== undefined) {
        return isNickName;
    } else {
        return db.getIn(['account', 'user', 'prezyvka']);
    }
});
export const hasUnevaluatedAnalysis$ = pathSubscription(['betbook', 'hasRewards']);

export const forcedRequestedKyc$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['account', 'userData', 'forcedRequestedKyc'])
        : pathSubscription(['account', 'user', 'forcedRequestedKyc']);
